<template>
    <!-- 底部尾部公用 -->
    <div>
        <div class="footer">
            <div class="footer_top">
                <div class="containers">
                    <div class="footer_top_left">
                        <!-- <a href="../../index.html"> -->
                        <img class="logo_footer" src="../../assets/imgs/componentsPic/logo_footer.png" />
                        <!-- </a> -->
                        <div class="quick_url">
                            <span>快速通道：</span>
                            <router-link :to="{ path: '/comdedeauto' }">产品中心</router-link>
                            <router-link :to="{ path: '/solutionadmi' }">解决方案</router-link>
                            <router-link :to="{ path: '/companyNews' }">新闻动态</router-link>
                            <router-link :to="{ path: '/companyprofile' }">关于我们</router-link>
                            <router-link :to="{ path: '/jobmarket' }">职等你来</router-link>
                        </div>
                    </div>
                    <div class="footer_top_right">
                        <!-- 产品网站 -->
                        <div class="url_btn" @click="openList">
                            <span>产品网站</span>
                            <img class="urlIcon" :src="iconUrl" />
                        </div>
                        <ul class="product_url" v-show="isOpen">
                            <li><a href="https://www.dedeauto.com/#/" target="_blank">得得用车官网</a></li>
                            <!-- <li>万物理想官网</li> -->
                        </ul>
                    </div>
                </div>
            </div>
            <div class="footer_bottom containers">
                <div class="footer_bottom_left">
                    <div>
                        <div class="company_address">
                            <div>
                                <span class="company_name">[ 成都本部 ]</span>
                                <span class="company_name">[ 甘肃办事处 ]</span>
                            </div>
                            <div>
                                <span class="address">地址：成都市高新区天府五街999号1栋22层2205、2206号</span>
                                <span class="address">地址：兰州市七里河区兰州中心1幢2701室</span>
                            </div>
                            <div>
                                <span class="tel">电话：028-8339 8557</span>
                                <span class="tel">电话：0931-8339 8557</span>
                            </div>
                        </div>
                        <div class="put_records">
                            <span class="copyright">© Copyright 2021 Wideal.cn All Right Reserved.</span>
                            <span>
                                <a style="color: #777777" href="https://beian.miit.gov.cn/" target="_blank">
                                    蜀ICP备20001180号-1
                                </a>
                            </span>
                        </div>
                    </div>
                </div>
                <div class="footer_bottom_right">
                    <img class="gz_code" src="../../assets/imgs/componentsPic/QR_code.png" />
                    <p>关注公众号</p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            iconUrl: require("../../assets/imgs/componentsPic/icon_urlOpen.png"),
            isOpen: false
        };
    },
    methods: {
        openList() {
            if (this.isOpen) {
                this.iconUrl = require("../../assets/imgs/componentsPic/icon_urlOpen.png");
                this.isOpen = false;
            } else {
                this.iconUrl = require("../../assets/imgs/componentsPic/icon_urlDown.png");
                this.isOpen = true;
            }
        }
    }
};
</script>

<style scoped>
@media screen and (max-width: 898px) {
    .footer .quick_url {
        width: 360px;
    }
}

@media screen and (min-width: 898px) and (max-width: 1067px) {
    .footer .quick_url {
        width: 400px;
    }
}

@media screen and (min-width: 1067px) {
    .footer .quick_url {
        width: 36vw;
    }
}
</style>
